import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { RewardBoxComponent } from '@app/shared/components/reward-box/reward-box.component';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { User } from '@app/shared/models/user.model';
import { SharedModule } from '@app/shared/shared.module';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-tournament-reward',
  templateUrl: './tournament-reward.component.html',
  styleUrls: ['./tournament-reward.component.scss'],
  standalone: true,
  imports: [ButtonComponent, RewardBoxComponent, SharedModule],
})
export class TournamentRewardComponent implements OnInit {
  tournamentRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private translateService = inject(TranslateService);
  private userRepo = inject(UserRepository);
  private eventManager = inject(EventManager);

  private lang: string;
  readonly PODIUM = 3;

  buttonText: string;
  positionText: string;

  get user(): User {
    return this.userRepo.getUser();
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang;
    this.positionText = this.getPositionText();
    this.buttonText = this.getButtonText();
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.tournamentRewardModalData.id, ModalType.Persisted, this.tournamentRewardModalData)
    );
  }

  private getPositionText(): string {
    const position: number = this.tournamentRewardModalData.properties.position;

    return position <= this.PODIUM ? String(position) : 'other';
  }

  private hasReward(): boolean {
    return !!this.tournamentRewardModalData.reward.credits || !!this.tournamentRewardModalData.reward.gems;
  }

  private getButtonText(): string {
    return this.tournamentRewardModalData.properties.buttonText[this.lang]
      ? this.tournamentRewardModalData.properties.buttonText[this.lang]
      : this.hasReward()
        ? 'home.buttons.great'
        : 'home.buttons.got-it';
  }
}
